// extracted by mini-css-extract-plugin
export default {"sideNav":"SideMenu_sideNav__CCRQ8","logoutButton":"SideMenu_logoutButton__YfJVm","showNav":"SideMenu_showNav__r+KoI"};